import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {auth, logInWithEmailAndPassword, sendPasswordReset} from "../../tools/firebase";
import "./Reset.css";

import {Button, Image, Space, Layout} from "antd";
import { Typography } from 'antd';
import { Input } from 'antd';
import {EyeInvisibleOutlined, EyeTwoTone, KeyOutlined, UserOutlined, MailOutlined} from "@ant-design/icons";
import {track} from "@amplitude/analytics-browser";
import logo from "../Resources/logo.png";

const { Title, Text } = Typography;
const { Header } = Layout;

function Reset() {
    const [email, setEmail] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) return;
        if (user) navigate("/dashboard");
    }, [user, loading]);

    useEffect(() => {
        track("reset_shown");
    }, []);

    return (
        <div>
            <Header className="header">
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <Space direction="horizontal" size="small">
                        <Image src={logo} preview={false} style={{width: 64, height: 64}}/>
                        <Title
                            level={3}
                            style={{color: "white", marginTop: 12}}
                            onClick={() => { navigate("/") }}
                        >
                            Dimensions
                        </Title>
                    </Space>
                </div>
            </Header>
            <div className="reset">
                <div className="reset__container">
                    <Image preview={false} src={logo} style={{width: 96, height: 96}}/>
                    <Title>Dimensions</Title>
                    <Text type="secondary" style={{marginBottom: 16}}>Reset your password</Text>
                    <Input
                        placeholder="E-mail Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        prefix={<MailOutlined />}
                        style={{marginBottom: 16}}
                    />
                    <Button
                        onClick={() => sendPasswordReset(email)}
                        type="primary"
                        style={{marginBottom: 16}}
                    >
                        Send password reset email
                    </Button>
                    {/*<div>*/}
                    {/*    Don't have an account? <Link to="/register">Register</Link> now.*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
}

export default Reset;